import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

// Updates the triage fields an admin can set from the dashboard. Omitted fields
// are left unchanged.
export const updateProductFeedback = unaryRpc({
  name: "updateProductFeedback" as const,
  input: z.object({
    // Numeric string for a CRDB bigint PK; the handler feeds it to BigInt(),
    // so reject non-numeric values here as a 400 instead of a server error.
    id: z.string().regex(/^\d+$/, "id must be a numeric string"),
    // One-way flags: only `true` is accepted; they can never be unset.
    resolved: z.literal(true).optional(),
    contacted: z.literal(true).optional(),
    // Reassign to a category's owning team; validated against the canonical
    // category keys server-side (the SDK stays free of the agent module).
    category: z.string().optional(),
    // Override the classified type; validated server-side like category.
    feedbackType: z.string().optional(),
  }),
  output: z.object({ success: z.literal(true) }),
});

export type UpdateProductFeedbackInput = z.infer<
  typeof updateProductFeedback.input
>;
